import { SET_ANALYTICS, CLEAR_ANALYTICS } from "../actions/analyticsActions";

const initialState = {
  analytics: {}
}

function analyticsReducer(state = initialState, action) {
  switch (action.type) {
  case SET_ANALYTICS:
    return {
      ...state,
      analytics: action.payload
    }
  case CLEAR_ANALYTICS:
    return {
      ...state,
      analytics: {}
    }
  default:
    return state;
  }
}

export default analyticsReducer;